angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('intro/intro.tpl.html',
    '<a class="intro-close-button right" ng-click="introDialog.close()">\n' +
    '  <i class="fa fa-times fa-2x"></i>\n' +
    '</a>\n' +
    '\n' +
    '<iframe width="800" height="450" src="https://www.youtube.com/embed/j5BByZo2kH4?autoplay=1" frameborder="0" allowfullscreen></iframe>\n' +
    '');
}]);
